import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { PackagesActionTypes } from "./constants";
import { getPackages, PackagesApiResponseError, PackagesApiResponseSuccess } from "./actions";
import { addPackageApi, deletePackageApi, getPackagesApi, updatePackageApi } from "../../helpers/api/packages";

// Fetch Packages saga
function* getPackagesSaga(): SagaIterator {
  try {
    const response = yield call(getPackagesApi);
    const Packages = response?.data?.data?.packages;

    yield put(PackagesApiResponseSuccess(PackagesActionTypes.GET_PACKAGES, Packages));
  } catch (error: any) {
    yield put(PackagesApiResponseError(PackagesActionTypes.GET_PACKAGES, error));
  }
}

// Update package saga
function* updatePackageSaga({ payload: { id, name, description, price, duration, image, type, status } }: any): SagaIterator {
  try {
    const response = yield call(updatePackageApi, { id, name, description, price, duration, type, status }, image);
    const message = response?.data?.message;

    yield put(PackagesApiResponseSuccess(PackagesActionTypes.UPDATE_PACKAGES, message));
    yield put(getPackages());
  } catch (error: any) {
    yield put(PackagesApiResponseError(PackagesActionTypes.UPDATE_PACKAGES, error));
  }
}

// Add new package saga
function* addPackageSaga({ payload: { name, description, price, duration, image, type } }: any): SagaIterator {
  try {
    const response = yield call(addPackageApi, { name, description, price, duration, image, type });
    const message = response?.data?.message;

    yield put(PackagesApiResponseSuccess(PackagesActionTypes.ADD_PACKAGES, message));
    yield put(getPackages());
  } catch (error: any) {
    yield put(PackagesApiResponseError(PackagesActionTypes.ADD_PACKAGES, error));
  }
}
// Delete package saga
function* deletePackageSaga({ payload: { id } }: any): SagaIterator {
  try {
    const response = yield call(deletePackageApi, { id });
    const message = response?.data?.message;

    yield put(PackagesApiResponseSuccess(PackagesActionTypes.DELETE_PACKAGES, message));
    yield put(getPackages());
  } catch (error: any) {
    yield put(PackagesApiResponseError(PackagesActionTypes.DELETE_PACKAGES, error));
  }
}

// Watchers
export function* watchGetPackages() {
  yield takeEvery(PackagesActionTypes.GET_PACKAGES, getPackagesSaga);
}

export function* watchUpdatepackage() {
  yield takeEvery(PackagesActionTypes.UPDATE_PACKAGES, updatePackageSaga);
}

export function* watchAddpackage() {
  yield takeEvery(PackagesActionTypes.ADD_PACKAGES, addPackageSaga);
}

export function* watchDeletepackage() {
  yield takeEvery(PackagesActionTypes.DELETE_PACKAGES, deletePackageSaga);
}

// Root saga
function* PackagesSaga() {
  yield all([fork(watchGetPackages), fork(watchUpdatepackage), fork(watchAddpackage), fork(watchDeletepackage)]);
}

export default PackagesSaga;
